export default __webpack_public_path__ + "static/media/execute-icon.13159c4b.svg";